import { auth } from "./firebase";

const FUNCTIONS_BASE_URL = process.env.REACT_APP_FUNCTIONS_BASE_URL || "https://us-central1-schedana-dev-f94d2.cloudfunctions.net";

export class ReviewService {
  private async getAuthToken(): Promise<string> {
    const user = auth.currentUser;
    if (!user) {
      throw new Error("User not authenticated");
    }
    return await user.getIdToken();
  }

  async triggerWeeklyReview(): Promise<void> {
    try {
      const token = await this.getAuthToken();
      const response = await fetch(`${FUNCTIONS_BASE_URL}/triggerWeeklyReview`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to trigger weekly review");
      }

      const result = await response.json();
      console.log("Weekly review triggered successfully:", result);
    } catch (error) {
      console.error("Error triggering weekly review:", error);
      throw error;
    }
  }

  async triggerDailyReview(): Promise<void> {
    try {
      const token = await this.getAuthToken();
      const response = await fetch(`${FUNCTIONS_BASE_URL}/triggerDailyReview`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to trigger daily review");
      }

      const result = await response.json();
      console.log("Daily review triggered successfully:", result);
    } catch (error) {
      console.error("Error triggering daily review:", error);
      throw error;
    }
  }
}

export const reviewService = new ReviewService();
